module.exports = __webpack_public_path__ + "./kit/docs/img/star-selected.da2c46ef93254567e4833a99f5ef660d.svg";